import FileOpenIcon from "@mui/icons-material/FileOpen";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import SavingsIcon from "@mui/icons-material/Savings";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Link,
  Switch,
  TextField,
  Typography,
  Tooltip,
  Chip
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import Header from "../components/Header";

// export const FormatedDate = ({ value }) => {
//   const timestamp = value;
//   const date = new Date(timestamp);

//   const hours = String(date.getHours() % 12 || 12).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const amOrPm = date.getHours() >= 12 ? "PM" : "AM";

//   var formattedDae = `${hours}:${minutes} ${amOrPm}`;
//   return <span>{formattedDae}</span>;
// };
export const FormatedDate = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <span>{formattedDate}</span>;
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ItemL = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderRadius: "17px",
  margin: "10px",
}));

const ItemC = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  borderRadius: "17px",
  margin: "10px",
}));
export const FormatedDateAll = ({ value }) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours() % 12 || 12).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const amOrPm = date.getHours() >= 12 ? "PM" : "AM";

  const formattedDate = `${year}/${month}/${day} ${hours}:${minutes} ${amOrPm}`;
  return <span>{formattedDate}</span>;
};

export const MemberPsb = ({ params }) => {
  const navigate = useNavigate();
  const handlePsb = () => {
    navigate("/onemember/", {
      state: {
        Member_id: params.row.member_id,
        Fullname: `${params.row.firstname} ${params.row.middlename}`,
      },
    });
  };
  return (
    <Link
      // variant="h6"
      color="darkblue"
      sx={{ fontWeight: "700" }}
      underline="none"
      component="button"
      // color="inherit"
      onClick={handlePsb}
    >
      {params.row.firstname} {params.row.lastname}
    </Link>
  );
};

export const MemberPsbb = ({ params }) => {
  const navigate = useNavigate();
  const handlePsb = () => {
    navigate("/Passbook/", {
      state: {
        Member_id: params.row.member_id,
        Fullname: `${params.row.firstname} ${params.row.lastname}`,
        Psb: params.row.association_members_id,
      },
    });
  };
  return (
    <IconButton onClick={handlePsb}>
      <FileOpenIcon />
    </IconButton>
  );
};

export default function AssociationPassBook() {
  const location = useLocation();
  const association_id = location.state && location.state.id;
  const association_name = location.state && location.state.association_name;
  const [open_acc, setOpen_acc] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [alert, setAlert] = useState();
  const [accounts, setAccounts] = useState([]);
  const [savingsTotal, setSavingsTotal] = useState(0);
  const [sharesTotal, setSharesTotal] = useState(0);
  const [loansTotal, setLoansTotal] = useState(0);
  const [commodityTotal, setCommodityTotal] = useState(0);
  const [associationWorth, setAssociationWorth] = useState(0);
  const [associationWorth_today, setAssociationWorth_today] = useState(0);
  const [todaysSavingsTransactions, setTodaysSavingsTransactions] = useState(0);
  const [holdSavingsTransactions, setHoldSavingsTransactions] = useState([]);
  const [SavingsTransactions, setSavingsTransactions] = useState([]);
  const [loanTransactions, setLoanTransactions] = useState([]);
  const [todayLoanTransactions, setTodayLoanTransactions] = useState([]);
  const [todayLoanTransactions_balance, setTodayLoanTransactions_balance] =
    useState([]);
  const [shareTransactions, setShareTransactions] = useState([]);
  const [todayShareTransactions, setTodayShareTransactions] = useState([]);
  const [todayShareTransactions_balance, setTodayShareTransactions_balance] =
    useState([]);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [mass, setMass] = useState();
  const [dataTMessage, setDataMessage] = useState("");
  const [date, setDate] = useState(dayjs());
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [start_dateag, setStart_dateag] = useState("");
  const [end_dateag, setEnd_dateag] = useState("");
  const [acc_name, setAcc_name] = useState("");
  const [cash_savings_total, setCash_savings_total] = useState([]);
  const [cash_save_total, setCash_save_total] = useState(null);
  const [cash_loans_total, setCash_loans_total] = useState(null);
  const [disbursed_loans_total, setDisbursed_loans_total] = useState(null);
  const [cash_shares_pur_total, setCash_shares_pur_total] = useState(null);
  const [cash_shares_wit_total, setCash_shares_wit_total] = useState(null);
  const [cash_total, setCash_total] = useState(null);
  const [momo_total, setMomo_total] = useState(null);
  const [withdrawals_total, setWithdrawals_total] = useState(null);
  const [transfer_deposits, setTransfer_deposits] = useState(null);
  const [transfer_withdrawals, setTransfer_withdrawal] = useState(null);
  const [new_data, setNew_data] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const printRef = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 20;
    const marginTop = 20;
    const marginRight = 20;
    const marginBottom = 20;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("TransactionalSummary.pdf");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEcash = () => {
    const somm = {
      association_id: association_id,
      typee: "savings",
      date: dayjs(),
    };
    api
      .post("/association/cash/settings", somm, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    handleEcash();
  }, [association_id]);

  useEffect(() => {
    setMass();
    handleEcash();
  }, [checked]);

  const transact_sum = () => {
    const florida = new FormData();
    florida.append("association_id", association_id);
    florida.append("date", date);
    florida.append("checked", checked);
    florida.append("start_date", start_date);
    florida.append("end_date", end_date);
    api
      .post("/association/transaction/sumary/perfect", florida, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (!response.data?.message) {
          setDataMessage();
          setCash_savings_total(response.data?.data);
          setCash_save_total(response.data?.cash_savings_totalA);
          setCash_loans_total(response.data?.cash_loans_totalA);
          setCash_shares_pur_total(response.data?.cash_shares_total_purA);
          setCash_shares_wit_total(response.data?.cash_shares_total_withA);
          setCash_total(response.data?.cash_totalA);
          setMomo_total(response.data?.momo_totalA);
          setWithdrawals_total(response.data?.withdrawals_totalA);
          setTransfer_deposits(response.data?.transfer_depositsA);
          setTransfer_withdrawal(response.data?.transfer_withdrawalsA);
          setDisbursed_loans_total(response.data?.loan_disbursedA);
        } else {
          setDataMessage("No data found for this period");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // console.log(cash_savings_total)
  const fetch_new_data = (account_id, type) => {
    const maimi = new FormData();
    maimi.append("association_id", association_id);
    maimi.append("account_id", account_id);
    maimi.append("account_type", type);
    maimi.append("date", date);
    maimi.append("checked", checked);
    maimi.append("start_date", start_date);
    maimi.append("end_date", end_date);
    api
      .post("/association/transaction/sumary/accounts", maimi, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (response.data === "Invalid Account") {
          toast.error(response.data);
        } else {
          setNew_data(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const transact_sum_form = (e) => {
    e.preventDefault();
    const florida = new FormData();
    florida.append("association_id", association_id);
    florida.append("date", date);
    florida.append("checked", checked);
    florida.append("start_date", start_date);
    florida.append("end_date", end_date);
    api
      .post("/association/transaction/sumary/perfect", florida, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (!response.data?.message) {
          setDataMessage();
          setCash_savings_total(response.data?.data);
          setCash_save_total(response.data?.cash_savings_totalA);
          setCash_loans_total(response.data?.cash_loans_totalA);
          setCash_shares_pur_total(response.data?.cash_shares_total_purA);
          setCash_shares_wit_total(response.data?.cash_shares_total_withA);
          setCash_total(response.data?.cash_totalA);
          setMomo_total(response.data?.momo_totalA);
          setWithdrawals_total(response.data?.withdrawals_totalA);
          setTransfer_deposits(response.data?.transfer_depositsA);
          setTransfer_withdrawal(response.data?.transfer_withdrawalsA);
          setDisbursed_loans_total(response.data?.loan_disbursedA);
        } else {
          setDataMessage("No data found for this period");
          toast.warning("No data found for this period");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // const transact_sum_filtered = () => {
  //   const florida = new FormData()
  //   florida.append('association_id', id)
  //   florida.append('start_date', start_date)
  //   florida.append('end_date', end_date)
  //   api.post(`/association/transaction/sumary`, florida, {
  //     headers: {
  //       Authorization: 'Bearer '+fetchToken()
  //     },
  //   }).then(function (response){
  //       setDataTransaction(response.data?.data);
  //   }).catch(function (error){
  //     console.log(error)
  //   })
  // }



  const handleFormChange = (event) => {
    setChecked(event.target.checked);
  };

  const TodayColumns = [
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      width: 50,
      renderCell: (params) => (
        <FormatedDateAll value={params.row.transaction_date} />
      ),
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "transaction_id",
      flex: 1,
    },
    {
      field: "firstname",
      headerName: "Member Name",
      flex: 1,
      renderCell: (params) => `${params.row.firstname} ${params.row.lastname}`,
    },
    {
      field: "association_members_id",
      headerName: "bond_id",
      flex: 1,
    },
    {
      field: "passbook_id",
      headerName: "Passbook Number",
      flex: 1,
    },
    {
      field: "lastname",
      headerName: "Lastname",
      flex: 1,
    },
    {
      field: "member_id",
      headerName: "Member id",
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        <Typography
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>{params.row.transactiontype_name === "Withdraw" ? currencyFormat.format(params.row.amount) : currencyFormat.format(0)}</b>
        </Typography>
    },
    {
      field: "credit",
      headerName: "Credit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>
        <Typography
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>{params.row.transactiontype_name === "Deposit" ? currencyFormat.format(params.row.amount) : currencyFormat.format(0)}</b>
        </Typography>
    },
    {
      field: "narration",
      headerName: "Narration",
      flex: 1,
      width: 70,
    },
    {
      field: "transactiontype_name",
      headerName: "Type",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount(GHS)",
      flex: 1,
    },
    {
      field: "account_name",
      headerName: "Account",
      flex: 1,
    },
    {
      field: "do",
      type: "actions",
      renderCell: (params) => <MemberPsbb {...{ params }} />,
    },
  ];

  const ClickActions = (e) => {
    e.preventDefault();
    const som = {
      association_id: association_id,
      date: date,
      checked: checked,
      start_date: start_date,
      end_date: end_date,
      typee: typee,
    };
    api
      .post("/association/today/everything", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const ClickActionsdd = () => {
    const som = {
      association_id: association_id,
      date: date,
      checked: checked,
      start_date: start_date,
      end_date: end_date,
      typee: typee,
    };
    api
      .post("/association/today/everything", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const ClickActionsag = (e) => {
    e.preventDefault();
    const som = {
      association_id: association_id,
      date: date,
      checked: checked,
      start_date: start_dateag,
      end_date: end_dateag,
      typee: typee,
      acc_name: acc_name,
    };
    api
      .post("/association/today/everything/fil", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const ClickActionsab = () => {
    const som = {
      association_id: association_id,
      date: date,
      checked: checked,
      start_date: start_dateag,
      end_date: end_dateag,
      typee: typee,
      acc_name: acc_name,
    };
    api
      .post("/association/today/everything/fil", som, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMass(response.data?.All_One);
        setTotal_wit(response.data?.total_wit);
        setTotal_dep(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (acc_name !== "") {
      ClickActionsab();
    }
  }, [acc_name]);

  const whatisit = (type) => {
    setTypee(type);
    ClickActionsdd();
  };

  const [value1, setValue1] = useState(0);

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handledate = (value) => {
    setDate(value);
  };
  useEffect(() => {
    ClickActionsab()
  }, [association_id, date]);

  const [total_wit, setTotal_wit] = useState();
  const [total_dep, setTotal_dep] = useState();
  const [typee, setTypee] = useState("savings");

  useEffect(() => {
    if (acc_name !== "") {
      ClickActionsdd();
    }
  }, [acc_name]);
  // useEffect(() => {
  //   const data = new FormData();
  //   data.append("association_id", association_id);
  //   data.append("date", date);
  //   api
  //     .post("/association/passbook/info/one/thing", data, {
  //       headers: {
  //         Authorization: "Bearer " + fetchToken(),
  //       },
  //     })
  //     .then(function (response) {
  //       setDta(response.data?.all);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // }, [date]);
  // when clicked
  const fetch_more = (id) => {
    api
      .get(`/association/passbook/info/data/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMore_data(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const fetchwhateveryeah = () => {
  //   api
  //     .get(`/association/passbook/info/${association_id}`, {
  //       headers: {
  //         Authorization: "Bearer " + fetchToken(),
  //       },
  //     })
  //     .then(function (response) {
  //       setDta(response.data?.all);
  //       // console.log(response.data?.all)
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   fetchwhateveryeah();
  // }, []);

  function fetchAccounts() {
    api
      .get(`/association/passbook/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAccounts(response.data);
        setHoldSavingsTransactions(response.data?.Todays_Savings_Transactions);
        setSavingsTransactions(response.data?.Savings_Transactions);
        setTodayLoanTransactions(response.data?.Todays_Loans_Transactions);
        setLoanTransactions(response.data?.Loans_Transactions);
        setTodayShareTransactions(response.data?.Todays_Shares_Transactions);
        setShareTransactions(response.data?.Shares_Transactions);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchAccounts();
  }, [association_id]);

  // console.log(accounts);

  // Total Savings Account Balance
  useEffect(() => {
    if (accounts.All_Savings_account) {
      let totalSaveValue = 0;
      accounts.All_Savings_account.forEach((saveItem) => {
        totalSaveValue += saveItem.current_balance;
      });
      setSavingsTotal(totalSaveValue);
    }
  }, [accounts.All_Savings_account]);

  //   console.log(savingsTotal);

  //   Total Shares Account Balance
  useEffect(() => {
    if (accounts.All_Shares_acount) {
      let totalshareValue = 0;
      accounts.All_Shares_acount.forEach((shareItem) => {
        totalshareValue += shareItem.current_balance;
      });
      setSharesTotal(totalshareValue);
    }
  }, [accounts.All_Shares_acount]);

  //   console.log(sharesTotal);

  //   Total Loans Account Balance
  useEffect(() => {
    if (accounts.All_Loans_account) {
      let totalloanValue = 0;
      accounts.All_Loans_account.forEach((loanItem) => {
        totalloanValue += loanItem.current_balance;
      });
      setLoansTotal(totalloanValue);
    }
  }, [accounts.All_Loans_account]);

  //   console.log(loansTotal);

  //   Total Commodity Account Balance
  useEffect(() => {
    if (accounts.All_Commodity_account) {
      let totalcommodityValue = 0;
      accounts.All_Commodity_account.forEach((commodityItem) => {
        totalcommodityValue += commodityItem.amt_valued;
      });
      setCommodityTotal(totalcommodityValue);
    }
  }, [accounts.All_Commodity_account]);

  //   console.log(commodityTotal);

  // Today's Saving transaction Amount
  useEffect(() => {
    if (accounts.Todays_Savings_Transactions) {
      let totalsaveTodayValue = 0;
      accounts.Todays_Savings_Transactions.forEach((saveItem) => {
        if (saveItem.transactiontype_name === "Withdraw") {
          totalsaveTodayValue -= saveItem.amount;
        } else {
          totalsaveTodayValue += saveItem.amount;
        }
      });
      setTodaysSavingsTransactions(totalsaveTodayValue);
    }
  }, [accounts.Todays_Savings_Transactions]);
  //   console.log(todaysSavingsTransactions);

  // Today's Loan transaction Amount
  useEffect(() => {
    if (accounts.Todays_Loans_Transactions) {
      let totalsaveTodayValue = 0;
      accounts.Todays_Loans_Transactions.forEach((saveItem) => {
        if (saveItem.transactiontype_name === "Withdraw") {
          totalsaveTodayValue -= saveItem.amount;
        } else {
          totalsaveTodayValue += saveItem.amount;
        }
      });
      setTodayLoanTransactions_balance(totalsaveTodayValue);
    }
  }, [accounts.Todays_Loans_Transactions]);

  // Today's Share transaction Amount
  useEffect(() => {
    if (accounts.Todays_Shares_Transactions) {
      let totalsaveTodayValue = 0;
      accounts.Todays_Shares_Transactions.forEach((saveItem) => {
        if (saveItem.transactiontype_name === "Withdraw") {
          totalsaveTodayValue -= saveItem.amount;
        } else {
          totalsaveTodayValue += saveItem.amount;
        }
      });
      setTodayShareTransactions_balance(totalsaveTodayValue);
    }
  }, [accounts.Todays_Shares_Transactions]);

  useEffect(() => {
    setAssociationWorth(
      savingsTotal + sharesTotal + commodityTotal + loansTotal
    );
  }, [savingsTotal, loansTotal, sharesTotal, commodityTotal]);

  useEffect(() => {
    setAssociationWorth_today(
      todaysSavingsTransactions +
        todayShareTransactions_balance +
        todayLoanTransactions_balance
    );
  }, [
    todaysSavingsTransactions,
    todayLoanTransactions_balance,
    todayShareTransactions_balance,
  ]);

  const takeMe = (name) => {
    if (name === "save") {
      navigate("/passbooks/association", {
        state: {
          All: accounts?.All_Savings_account,
          association_name: association_name,
          type: name,
        },
      });
    } else if (name === "loan") {
      navigate("/passbooks/association", {
        state: {
          All: accounts?.All_Loans_account,
          association_name: association_name,
          type: name,
        },
      });
    } else if (name === "share") {
      navigate("/passbooks/association", {
        state: {
          All: accounts?.All_Shares_acount,
          association_name: association_name,
          type: name,
        },
      });
    } else if (name === "commodity") {
      navigate("/passbooks/association", {
        state: {
          All: accounts?.All_Commodity_account,
          association_name: association_name,
          type: name,
        },
      });
    }
  };
  //  console.log(dta)
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="app">
        <main className="content">
          <Box sx={{ m: 5 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header
                title="Savings Group Passbook"
                subtitle="Accounts and details"
              />
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                  <Typography sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h3">
                    <b>{association_name}'s Passbook</b>
                  </Typography>
              </Grid>
              {/* Association Worth = (savings balance + shares balance + commodity value - loan balance) */}
              <Grid item xs={12} md={4}>
                <Card
                  sx={{
                    minWidth: 280,
                    margin: 4,
                    display: "flex",
                    borderRadius: 7,
                  }}
                >
                  <CardContent>
                    <IconButton aria-label="previous">
                      <PaidIcon />
                    </IconButton>
                    <Typography gutterBottom variant="h5" component="div">
                      Today's Savings:{" "}
                      <span style={{ fontWeight: "500" }}>
                        GH₵{todaysSavingsTransactions}
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              {/* Today's Total Savings = savings total amount from 12 o'clock in the morning to 12 midnight  */}
              <Grid item xs={12} md={4}>
                <Card
                  sx={{
                    minWidth: 280,
                    margin: 4,
                    display: "flex",
                    borderRadius: 7,
                  }}
                >
                  <CardContent>
                    <IconButton aria-label="previous">
                      <SavingsIcon />
                    </IconButton>
                    <Typography gutterBottom variant="h5" component="div">
                      Today's Worth:{" "}
                      <span style={{ fontWeight: "500" }}>
                        GH₵{associationWorth_today}
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              {/* Today's Worth = savings balance + shares balance + commodity value - loan balance from 12 o'clock in the morning to 12 midnight  */}
              <Grid item xs={12} md={4}>
                <Card
                  sx={{
                    minWidth: 280,
                    margin: 4,
                    display: "flex",
                    borderRadius: 7,
                  }}
                >
                  <CardContent>
                    <IconButton aria-label="previous">
                      <PriceCheckIcon />
                    </IconButton>
                    <Typography gutterBottom variant="h5" component="div">
                      Savings Group's Worth:{" "}
                      <span style={{ fontWeight: "500" }}>
                        GH₵{associationWorth}
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={12} sx={{mb:30}}>
                <ItemC>
                  <div style={{ display: "flex" }}>
                    <Typography
                      sx={{ margin: "5px", color: "#003049" }}
                      fontStyle="normal"
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Use period</b>
                    </Typography>
                    <Switch
                      checked={checked}
                      onChange={handleFormChange}
                      sx={{ color: "#001845" }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </div>
                  {checked === true ? (
                    <>
                      <Typography>Filter Date</Typography>
                      <div style={{ display: "flex" }}>
                        <form onSubmit={ClickActions}>
                          <TextField
                            type="date"
                            size="small"
                            required
                            variant="outlined"
                            helperText="From"
                            name="start_date"
                            onChange={(e) => setStart_date(e.target.value)}
                            value={start_date}
                            sx={{ mr: 1 }}
                          />

                          <TextField
                            type="date"
                            size="small"
                            required
                            variant="outlined"
                            helperText="To"
                            name="end_date"
                            onChange={(e) => setEnd_date(e.target.value)}
                            value={end_date}
                            sx={{ mr: 1 }}
                          />

                          <IconButton type="submit">
                            <FilterAltOutlinedIcon />
                          </IconButton>
                          {/* <IconButton onClick={transact_sum}><CancelIcon /></IconButton> */}
                        </form>
                      </div>
                    </>
                  ) : (
                    <div>
                      <StaticDatePicker
                        sx={{ width: 125, height: 425 }}
                        value={date}
                        onChange={(new_value) => handledate(new_value)}
                      />
                    </div>
                  )}
                </ItemC>

                <ItemC>
            <div>
              <Tooltip title="Double Click" placement="top">
                <div style={{ display: "flex" }}>
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("savings")}
                    sx={{ backgroundColor: "#012a4a", color: "#fff", m: "5px" }}
                    label="Savings acc Transactions"
                  />
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("share")}
                    sx={{ backgroundColor: "#013a63", color: "#fff", m: "5px" }}
                    label="Shares acc Transactions"
                  />
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("loan")}
                    sx={{ backgroundColor: "#01497c", color: "#fff", m: "5px" }}
                    label="Loan acc Transactions"
                  />
                  <Chip
                    variant="contained"
                    onClick={() => whatisit("transfer")}
                    sx={{ backgroundColor: "#014f86", color: "#fff", m: "5px" }}
                    label="Transfers Transactions"
                  />
                </div>
              </Tooltip>

              <div>
                <Typography
                  variant="subtitle"
                  fontStyle="normal"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  sx={{ textAlign: "center" }}
                >
                  <b>
                    Current table: <i>{typee} transactions</i>
                  </b>
                </Typography>
              </div>
              <Box>
                <TextField
                  size="small"
                  variant="outlined"
                  helperText="Account"
                  name="acc_name"
                  onChange={(e) => setAcc_name(e.target.value)}
                  value={acc_name}
                  sx={{ mr: 1 }}
                />
              </Box>
              {
                mass ?
                (
                  <DataGrid
                    rows={mass}
                    columns={TodayColumns}
                    autoHeight
                    checkboxSelection
                    getRowId={(row) => row.transaction_id}
                    slots={{ toolbar: GridToolbar }}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          id: false,
                          transaction_id: false,
                          lastname: false,
                          member_id: false,
                          amount: false,
                          username: false,
                          transactiontype_name: false,
                          association_members_id: false,
                        },
                      },
                      pagination: { paginationModel: { pageSize: 5 } },
                    }}
                    pageSizeOptions={[5, 10, 25]}
                  />
                ):null
              }
              
              <div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "5px",
                  }}
                >
                  <Typography variant="h5" sx={{ color: "red", mr: 4 }}>
                    Total:
                  </Typography>
                  <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
                    Debit: {total_wit}{" "}
                  </Typography>
                  <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
                    Credit: {total_dep}{" "}
                  </Typography>
                </div>
              </div>
            </div>
                </ItemC>
              </Grid>
            </Grid>
          </Box>
        </main>
      </div>
    </LocalizationProvider>
  );
}
